module.exports = "/virtual-football-league/img/video/vvb-body-bot.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/virtual-football-league/img/video/vvb-body-bot.png
// module id = 363
// module chunks = 4